// extracted by mini-css-extract-plugin
var _1 = "RentalPortalOverview-moduleRentalPortalOverview__cI_0M";
var _2 = "RentalPortalOverview-moduleheader__L0eNZ";
export { _1 as "RentalPortalOverview", _2 as "header" }
